import { Text } from '@blocksuite/store';
import { Doc } from 'yjs';

let textHostDocs = 0;

/**
 * A document that only hosts a single cell text, which needs a document to
 * be read. It is never synced or nested, so a counter names it: a random
 * name costs 31 random draws, and reading a table builds one per text cell.
 */
export function textHostDoc(): Doc {
  textHostDocs += 1;
  return new Doc({ guid: `database-cell-text-${textHostDocs}` });
}

/** A cell text holding `value`, in a document of its own. */
export function textFromString(value: string): Text {
  const yText = textHostDoc().getText('text');
  yText.insert(0, value);
  return new Text(yText);
}
